import { client } from '@/client';

// 图表信息
export function getChartsData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/bookie/${clusterName}/overview`, others);
}

// 恢复图表信息
export function getAutoRecoveryChartsData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/auto-recovery/${clusterName}/overview`, others);
}

// 总览数据
export function getOverview(clusterName) {
  return client.get(`/api/metrics/bookie/${clusterName}/overview`);
}

// 恢复数据总览
export function getRecoveryOverview(clusterName) {
  return client.get(`/api/metrics/bookie/autorecovery/${clusterName}/overview`);
}

// 获取Bookie列表
export function getBookkeeperList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/bookie/${clusterName}/list`, others);
}

/** 单个server图表数据 */
export function getServerChart(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/bookie/${clusterName}`, others);
}

// 获取配置信息
export function getConfigList(params) {
  const { clusterName, bookieHost, ...others } = params;
  return client.get(`/api/metrics/bookie/configuration/${clusterName}/${bookieHost}`, others);
}

// GC详情
export function getGCDetailList(bkHost, metricsPort, params) {
  return client.get(`/api/bk/bookie/gc/detail/${bkHost}:${metricsPort}`, params);
}

// 触发GC
export function gcTrigger(bkHost, metricsPort, params) {
  return client.get(`/api/bk/bookie/gc/trigger/${bkHost}:${metricsPort}`, params);
}
